var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:_vm.className,on:{"click":function($event){return _vm.onClick($event)}}},[_c('span',{staticClass:"material-symbols-outlined",style:(`font-size: ${_vm.size}px`)},[_vm._v("\n    "+_vm._s(_vm.iconName)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }